
import { Options, Vue } from "vue-class-component";
import CustomBtn from "@/components/CustomBtn.vue";
import { kMobileComponyInfo } from "@/config/news";

@Options({
  components: {
    CustomBtn,
  },
  data() {
    return {
      btns: [
        {
          icon: require("@/assets/introduce/btn_buy_normal.png"),
          selectedIcon: require("@/assets/introduce/btn_buy_selected.png"),
          title: "数字化采购",
        },
        {
          icon: require("@/assets/introduce/bit_system_normal.png"),
          selectedIcon: require("@/assets/introduce/bit_system_selected.png"),
          title: "品控标准体系",
        },
        {
          icon: require("@/assets/introduce/btn_shopping_cart_normal.png"),
          selectedIcon: require("@/assets/introduce/btn_shopping_cart_selected.png"),
          title: "高效率供应链",
        },
      ],
      stores: [
        {
          img: require("@/assets/introduce/d_shc.jpg"),
        },
        {
          img: require("@/assets/introduce/d_zjc.jpg"),
        },
        {
          img: require("@/assets/introduce/d_jxc.jpg"),
        },
        {
          img: require("@/assets/introduce/d_xac.jpg"),
        },
      ],
    };
  },
})
export default class Delivery extends Vue {}
